import initDrawer from "./initDrawer";
import initHeader from "./initHeader";
import initSmoothScroll from "./initSmoothScroll";
import initViewport from "./initViewport";

export default function initCommonScript() {
  // viewport固定
  initViewport();

  // headerコンテンツ
  initHeader();

  // スムーススクロール
  initSmoothScroll();

  // ドロワーメニュー
  initDrawer();
}
